import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAttendeeCircleIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 24 24",
	fill: "currentColor",
	...props,
	children: [/* @__PURE__ */ _jsx("circle", {
		cx: 12,
		cy: 12,
		r: 12,
		color: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M15.5 16.5V15.5C15.5 14.9696 15.2893 14.4609 14.9142 14.0858C14.5391 13.7107 14.0304 13.5 13.5 13.5H10.5C9.96957 13.5 9.46086 13.7107 9.08579 14.0858C8.71071 14.4609 8.5 14.9696 8.5 15.5V16.5M14 9.5C14 10.6046 13.1046 11.5 12 11.5C10.8954 11.5 10 10.6046 10 9.5C10 8.39543 10.8954 7.5 12 7.5C13.1046 7.5 14 8.39543 14 9.5Z",
		stroke: "black",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgAttendeeCircleIcon;
